import React, {useEffect, useState} from "react";
import Pagination from "react-js-pagination";
import queryString from "query-string";
import {NavLink, useLocation} from "react-router-dom";
import { useHistory } from "react-router";

import BreadCrumb from '../../Layout/Funlove/BreadCrumb';
import MovieListComponent from "../Components/MovieListComponent";
import {getMoviesByAlias} from "./Components/index";
import {FormatNumber, CreateParame} from "../../Lib/helper";
import {activeOrderLink} from "../Components/ActiveLink";
import {activeMenu} from "../Components";
import BoxAds from "../Components/BoxAds";
import Messages from "../../Config/Messages";
import MetaTags from "react-meta-tags";
import CategorieTagComponent from "../Components/CategorieTagComponent";
import AppConstants from "../../Config/AppConstants";

let pageLog = '';
let params = {};
let pageSort = '';

function Categories(props) {

    const [dataPage, setDataPage] = useState(null);
    let history = useHistory();
    const location = useLocation();
    useEffect(() => {
        params = queryString.parse(props.location.search);
        activeMenu('#categories');

        let pageCurrent = props.match.params.page;
        let getSort = props.match.params.sort;

        if(pageCurrent  < 1) {
            pageCurrent = 0;
        }

        pageSort = '';

        if(getSort != undefined) {
            pageSort = getSort;
        }

        getData(pageCurrent, pageSort);
    }, [location]);

    const sortList = (typeSort, page = 1) => {

        pageSort = typeSort;
        let strParams = CreateParame(params);

        let url = '/categorices/'+props.match.params.alias+'/'+page+'?'+strParams;
        if(pageSort != '') {
            url = '/categorices/'+props.match.params.alias+'/'+page+'/'+pageSort+'?'+strParams;
        }

        history.push(url);
    }


    const getData = async (page = 1, pageSort = '') => {

        let alias = props.match.params.alias;
        let result = await getMoviesByAlias(alias, params, page, pageSort);
        window.scrollTo(0, 0);
        pageLog = page
        setDataPage(result);
    }

    if(!dataPage) {
        return <></>
    }

    return (
        <>
            <BreadCrumb/>
            <MetaTags>
                <title>{`${dataPage.category.title} Funlove.info Watch High Quality Exclusive ${dataPage.category.title} Movies Online`}</title>
                <meta name="description" content={`Free High Quality Exclusive ${dataPage.category.title} Full Movie Streaming And Download`}/>
                <meta name="keywords" content={dataPage.category.title}/>
            </MetaTags>
            <section className="breadcrumb-wrapper visible-md-block visible-lg-block">
                <div className="container">
                    <ol className="breadcrumb">
                        <li>
                            <NavLink to='/' title='Home'>
                                <i className="glyphicon glyphicon-home"></i> Home
                            </NavLink>
                        </li>
                        <li className="active">Categories</li>
                        <li className="active">{`Watch Free ${dataPage.category.title} JAV HD and XXX FC2PPV Xnxx Xvideos sex videos on the Japanese Porn China AV`}</li>
                    </ol>
                </div>
            </section>
            <BoxAds></BoxAds>
            <div className="container">
                <div className="box">
                    <h1 className="title title-page" style={{float:"left"}}>{dataPage.category.title}</h1>
                    <CategorieTagComponent tags={dataPage.category.descriptions}></CategorieTagComponent>
                    <span className="movie-number">({FormatNumber(dataPage.total)})</span>
                    {activeOrderLink(pageSort, sortList)}
                    <div className="clearfix"></div>

                    <MovieListComponent movieList={dataPage.videos}/>

                    <div className="clearfix"></div>
                    <div style={{textAlign:"center", clear: "both"}}>

                        {dataPage.total > dataPage.limit ?
                            <Pagination
                                activePage={dataPage.pageCurrent}
                                itemsCountPerPage={dataPage.limit}
                                totalItemsCount={dataPage.total}
                                pageRangeDisplayed={5}
                                onChange={(pageNumber) => {
                                    if(pageNumber == pageLog) {
                                        return false;
                                    }
                                    sortList(pageSort, pageNumber)
                                }}
                            /> :
                            <></>
                        }
                    </div>
                </div>
            </div>
            <BoxAds></BoxAds>
        </>
    )
}

export default Categories;

